import { faEye } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useState } from "react";
import {
  Button,
  Form,
  InputGroup,
  Modal,
  Table,
  Tab,
  Tabs,
} from "react-bootstrap";
import "./College.css";
import { IndexUse } from "./IndexUse";
import CustomPaginate from "../../../../../../common/custompaginate/CustomPaginate";

const College = () => {
  const { country, name, setName, fetch } = IndexUse();

  const [selectedCollege, setSelectedCollege] = useState(null);
  const [showDetailsModal, setShowDetailsModal] = useState(false);

  const handlePageChange = async (page) => {
    await fetch(page);
  };

  const handleShowDetails = (college) => {
    setSelectedCollege(college);
    setShowDetailsModal(true);
  };

  const handleCloseModal = () => {
    setShowDetailsModal(false);
    setSelectedCollege(null);
  };

  return (
    <>
      <section className="Collage_intern application_section">
        <div className="serach_header">
          <InputGroup className="search_box">
            <Form.Control
              placeholder="Search College Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="search_input"
            />
            <div className="search_btn">
              <i className="fa fa-search"></i>
            </div>
          </InputGroup>
        </div>

        <div className="Dashboard__ActiveApplications card_box">
          <h5 className="mb-3 card_heading_holder">Colleges List</h5>

          <div className="custom_table table_scroll">
            <Table borderless responsive hover>
              <thead className="table-light">
                <tr>
                  <th>Sr. No.</th>
                  <th>College Name</th>
                  <th>Email</th>
                  <th>Contact Number</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {country?.data?.length > 0 ? (
                  country.data.map((val, index) => (
                    <tr key={val.id}>
                      <td>
                        {(country.current_page - 1) * country.per_page +
                          index +
                          1}
                      </td>
                      <td>
                        <strong>
                          {val.name} {val.last_name || ""}
                        </strong>
                      </td>
                      <td>{val.email}</td>
                      <td>{val.contact_no}</td>
                      <td>
                        <Button
                          variant="outline-info"
                          size="sm"
                          onClick={() => handleShowDetails(val)}
                        >
                          <FontAwesomeIcon icon={faEye} /> View Details
                        </Button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="5"
                      className="text-center py-4 fw-bold text-muted"
                    >
                      No Colleges Found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>

            <CustomPaginate
              currentPage={country?.current_page || 1}
              totalPages={country?.total_pages || 1}
              handlePageChange={handlePageChange}
            />
          </div>
        </div>
      </section>

      {/* ====================== COLLEGE DETAILS MODAL ====================== */}
      <Modal
        show={showDetailsModal}
        onHide={handleCloseModal}
        size="xl"
        centered
        scrollable
      >
        <Modal.Header closeButton className="bg-info text-white">
          <Modal.Title>
            <FontAwesomeIcon icon={faEye} className="me-2" />
            College Details - {selectedCollege?.name}{" "}
            {selectedCollege?.last_name || ""}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedCollege && (
            <Tabs defaultActiveKey="basic" className="mb-4" fill>
              {/* Basic Information */}
              <Tab eventKey="basic" title="Basic Information">
                <Table bordered hover responsive>
                  <tbody>
                    <tr>
                      <th>College Name</th>
                      <td>
                        <strong>{selectedCollege.name}</strong>
                      </td>
                    </tr>
                    <tr>
                      <th>Email</th>
                      <td>{selectedCollege.email}</td>
                    </tr>
                    <tr>
                      <th>Contact Number</th>
                      <td>{selectedCollege.contact_no}</td>
                    </tr>
                    <tr>
                      <th>Referral Code</th>
                      <td>{selectedCollege.referal_code || "N/A"}</td>
                    </tr>
                    <tr>
                      <th>Status</th>
                      <td>
                        <span
                          className={`badge ${
                            selectedCollege.status ? "bg-success" : "bg-danger"
                          }`}
                        >
                          {selectedCollege.status ? "Active" : "Inactive"}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <th>Registered On</th>
                      <td>
                        {new Date(selectedCollege.createdAt).toLocaleDateString(
                          "en-IN",
                        )}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Tab>

              {/* College Details */}
              <Tab eventKey="details" title="College Details">
                {selectedCollege.CollegeDetail ? (
                  <Table bordered hover responsive>
                    <tbody>
                      <tr>
                        <th>Website URL</th>
                        <td>
                          <a
                            href={selectedCollege.CollegeDetail.website_url}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {selectedCollege.CollegeDetail.website_url || "N/A"}
                          </a>
                        </td>
                      </tr>
                      <tr>
                        <th>Headquarter Address</th>
                        <td>
                          {selectedCollege.CollegeDetail.headquarter_address ||
                            "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <th>College Type</th>
                        <td>
                          {selectedCollege.CollegeDetail.CollegeType?.name ||
                            "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <th>Accreditation Authority</th>
                        <td>
                          {selectedCollege.CollegeDetail.acc_auth_name || "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <th>Accreditation Validity Period</th>
                        <td>
                          {selectedCollege.CollegeDetail.acc_val_period ||
                            "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <th>Registration Number</th>
                        <td>{selectedCollege.CollegeDetail.reg_no || "N/A"}</td>
                      </tr>
                      <tr>
                        <th>Country</th>
                        <td>
                          {selectedCollege.CollegeDetail.country || "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <th>State</th>
                        <td>{selectedCollege.CollegeDetail.state || "N/A"}</td>
                      </tr>
                      <tr>
                        <th>City</th>
                        <td>{selectedCollege.CollegeDetail.city || "N/A"}</td>
                      </tr>
                      <tr>
                        <th>Pincode</th>
                        <td>
                          {selectedCollege.CollegeDetail.pincode || "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <th>Street</th>
                        <td>{selectedCollege.CollegeDetail.street || "N/A"}</td>
                      </tr>
                      <tr>
                        <th>Send Students Abroad</th>
                        <td>
                          {selectedCollege.CollegeDetail.send_s_abroad
                            ? "Yes"
                            : "No"}
                        </td>
                      </tr>
                      <tr>
                        <th>Abroad Office Contact</th>
                        <td>
                          {selectedCollege.CollegeDetail.abroad_off_contact ||
                            "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <th>Annual Abroad Students</th>
                        <td>
                          {selectedCollege.CollegeDetail.abroad_stu_quantity ||
                            "N/A"}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                ) : (
                  <p className="text-center text-muted py-4">
                    No college details available.
                  </p>
                )}
              </Tab>

              {/* College Representative */}
              <Tab eventKey="representative" title="Representative">
                {selectedCollege.CollegeRepresentative ? (
                  <Table bordered hover responsive>
                    <tbody>
                      <tr>
                        <th>First Name</th>
                        <td>
                          {selectedCollege.CollegeRepresentative.r_first_name ||
                            "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <th>Last Name</th>
                        <td>
                          {selectedCollege.CollegeRepresentative.r_last_name ||
                            "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <th>Position</th>
                        <td>
                          {selectedCollege.CollegeRepresentative.r_position ||
                            "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <th>Email</th>
                        <td>
                          {selectedCollege.CollegeRepresentative.r_email ||
                            "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <th>Contact Number</th>
                        <td>
                          {selectedCollege.CollegeRepresentative.r_contact ||
                            "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <th>Authorized to Sign Internship</th>
                        <td>
                          {selectedCollege.CollegeRepresentative
                            .auth_to_sign_internship
                            ? "Yes"
                            : "No"}
                        </td>
                      </tr>
                      <tr>
                        <th>International Contact First Name</th>
                        <td>
                          {selectedCollege.CollegeRepresentative.i_c_f_name ||
                            "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <th>International Contact Last Name</th>
                        <td>
                          {selectedCollege.CollegeRepresentative.i_c_l_name ||
                            "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <th>International Contact No</th>
                        <td>
                          {selectedCollege.CollegeRepresentative
                            .i_c_contact_no || "N/A"}
                        </td>
                      </tr>
                      <tr>
                        <th>International Contact Email</th>
                        <td>
                          {selectedCollege.CollegeRepresentative.i_c_email ||
                            "N/A"}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                ) : (
                  <p className="text-center text-muted py-4">
                    No representative information available.
                  </p>
                )}
              </Tab>
            </Tabs>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default College;
